module.exports = __webpack_public_path__ + "media/images/animations/wide_loads/3-4691c64481cab74a16c24105a772a026.png";